<template>
  <!--footer-->
  <div class="radio_group flex-c pt10 pb10">

    <template  v-if="disable === false">
      <div class="radio_item" @click="chooseItem(value)" :class="value==radioValue?'checked':''">
        {{ radioTitle }}
      </div>
    </template>


    <template v-else>
      <div class="radio_item disable">
        {{ radioTitle}}
      </div>
    </template>
  </div>
  <!--footer end-->
</template>

<script>
  export default {
    name: 'radioSingle',
    props: {
      radioValue: {
        type: String,
        default: '',
      },
      radioTitle: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      disable: {
        type: Boolean,
        default: false,
      }, // 禁用
    },
    data () {
      return {

      }
    },
    methods: {
      chooseItem(){
        this.$emit('update:value', this.radioValue)
        this.$emit('update:label', this.radioTitle)
        this.$emit('change', this.radioValue)
      },
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/radio_single.vue